var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_973",
    "data-name": "Group 973",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43.718,
    height: 40,
    viewBox: "0 0 43.718 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_822",
    "data-name": "Rectangle 822",
    width: 43.718,
    height: 40,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_972",
    "data-name": "Group 972",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4248",
    "data-name": "Path 4248",
    d: "M921.291,162.511c-.388,0-.775.007-1.163,0-.164,0-.229.035-.221.213.014.33,0,.66.007.99,0,.143-.044.186-.184.182-.337-.009-.675-.01-1.012,0-.158.005-.193-.056-.189-.2.009-.337,0-.675.006-1.012,0-.13-.038-.176-.171-.173-.337.008-.675-.006-1.012.007-.166.006-.208-.051-.2-.208.012-.323.011-.646,0-.969-.005-.156.035-.216.2-.21.337.013.675,0,1.012.006.133,0,.174-.044.171-.174-.007-.337,0-.675,0-1.012,0-.145.033-.2.19-.2.344.011.689.007,1.033,0,.121,0,.163.038.161.16-.006.337.008.675-.007,1.012-.008.178.057.217.221.212.387-.011.775,0,1.163,0Z",
    transform: "translate(-877.574 -152.856)",
    fill: "#bbc0c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4249",
    "data-name": "Path 4249",
    d: "M31.177,202.849a9.121,9.121,0,0,1-1.278.823,19.885,19.885,0,0,1-3.728,1.649,18.652,18.652,0,0,1-3.312.759c-.616.078-1.232.137-1.852.179a16.211,16.211,0,0,1-1.676.024,20.126,20.126,0,0,1-2.7-.276,20.738,20.738,0,0,1-2.908-.717,18.73,18.73,0,0,1-1.762-.678,20.189,20.189,0,0,1-3.173-1.755,21.551,21.551,0,0,1-2.251-1.778,18.2,18.2,0,0,1-1.616-1.635,20.182,20.182,0,0,1-3.8-6.5,18.9,18.9,0,0,1-.811-3.083c-.126-.731-.208-1.466-.266-2.206a20.7,20.7,0,0,1-.025-2.469,18.326,18.326,0,0,1,.516-3.549,20.079,20.079,0,0,1,1.509-4.167,21.3,21.3,0,0,1,1.68-2.816,6.584,6.584,0,0,1,.674-.857c.11.114.07.258.07.389q0,4.986,0,9.971a3.4,3.4,0,0,0,3.455,3.453c.56,0,1.12,0,1.68,0,.182,0,.264-.058.254-.249a.548.548,0,0,1,.061-.395,1.043,1.043,0,0,1,.7,0,.666.666,0,0,1,.06.418q0,6,0,12a3.224,3.224,0,0,0,.679,2.025,3.334,3.334,0,0,0,2.751,1.365q8.325,0,16.65,0c.139,0,.29-.042.41.073",
    transform: "translate(0 -166.294)",
    fill: "#e9eaeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4250",
    "data-name": "Path 4250",
    d: "M107.579,49.712c0,.187-.007.373-.006.559,0,.081-.008.136-.113.133-.817-.023-1.637.054-2.452-.043a3.462,3.462,0,0,1-2.915-2.9,4.766,4.766,0,0,1-.039-.622q0-5.06,0-10.12c0-.064,0-.129-.006-.193q0-1.313.007-2.627a3.456,3.456,0,0,1,3.5-3.492l4.866-.007a2.058,2.058,0,0,1,.532-.064q6.7,0,13.4,0a2.082,2.082,0,0,1,.554.064q2.111,0,4.222.008a7.576,7.576,0,0,1,1.01.035,3.478,3.478,0,0,1,2.9,2.819,4.317,4.317,0,0,1,.05.638c.008.818.007,1.637.009,2.455a.686.686,0,0,1,.064.334q0,3.241,0,6.481c0,.372-.037.406-.406.408a3.355,3.355,0,0,1-.344-.006c-.165.009-.33,0-.5,0a.235.235,0,0,1-.27-.26c0-.086,0-.172,0-.258q0-1.637,0-3.274c0-.338,0-.343-.33-.343H103.844c-.332,0-.34.008-.341.334q0,3.576,0,7.151a2.01,2.01,0,0,0,2.024,2.029c.582,0,1.163,0,1.745,0,.319,0,.365.048.366.36a.607.607,0,0,1-.06.4",
    transform: "translate(-97.645 -29.025)",
    fill: "#1a5186"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4251",
    "data-name": "Path 4251",
    d: "M265.089,371.385q-2.143,0-4.287-.007-6.366,0-12.733,0a3.452,3.452,0,0,1-3.54-3.538q0-6.022,0-12.043c0-.093,0-.186-.007-.28a.461.461,0,0,1-.059-.31q0-.894,0-1.788a3.55,3.55,0,0,1,2.777-3.4,3.647,3.647,0,0,1,.747-.084q10.242,0,20.485,0c.065,0,.129,0,.194,0,1.211-.009,2.422-.015,3.633,0a1.764,1.764,0,0,1,1.063.279,3.828,3.828,0,0,1,1.336.953,3.32,3.32,0,0,1,.861,2.217q.009,7.3,0,14.6a3.452,3.452,0,0,1-2.957,3.349,4.311,4.311,0,0,1-.579.037H265.3c-.072,0-.143,0-.215.007",
    transform: "translate(-233.912 -334.829)",
    fill: "#2d3746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4252",
    "data-name": "Path 4252",
    d: "M808.368,177.882a5.366,5.366,0,0,0-1.905-.223c-.931.007-1.861,0-2.792,0a.79.79,0,0,1,0-.675,4.91,4.91,0,0,1,.495,0c.164.014.2-.042.2-.2-.007-1.386,0-2.771,0-4.157q0-1.4.006-2.8a10.375,10.375,0,0,1,.931,1.2c.3.433.583.881.855,1.336a19.963,19.963,0,0,1,2.2,5.4,1.087,1.087,0,0,1,.017.127",
    transform: "translate(-768.919 -162.49)",
    fill: "#e9eaeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4253",
    "data-name": "Path 4253",
    d: "M310.464,1.373q-2.421,0-4.841.007-4.713,0-9.425,0c-.072,0-.143,0-.215-.007a10.224,10.224,0,0,1,1.551-.554,20.324,20.324,0,0,1,2.881-.631c.485-.075.979-.1,1.468-.144A14.245,14.245,0,0,1,303.341,0a20.332,20.332,0,0,1,2.751.21,19.4,19.4,0,0,1,3.513.836,4.952,4.952,0,0,1,.859.327",
    transform: "translate(-283.211 0)",
    fill: "#e9eaeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4254",
    "data-name": "Path 4254",
    d: "M163.033,243.759q0,.337,0,.675-2.229,0-4.458.007-8.078,0-16.156,0a3.409,3.409,0,0,0-2.649,1.171,3.309,3.309,0,0,0-.869,2.213c-.013.71-.007,1.421-.01,2.132h-.675c0-.179-.013-.359,0-.538.006-.125-.04-.154-.158-.153-.617.005-1.235,0-1.852,0a2.074,2.074,0,0,1-2.13-2.138c0-2.434,0-4.868,0-7.3,0-.187.054-.217.226-.217q13.915.006,27.83,0c.2,0,.227.065.226.24-.007,1.235,0,2.47-.008,3.7,0,.157.031.217.2.2a4.655,4.655,0,0,1,.495,0",
    transform: "translate(-128.282 -229.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4255",
    "data-name": "Path 4255",
    d: "M73.62,578.011c-.172,0-.345.007-.517,0-.133-.007-.175.042-.172.173.007.345,0,.689,0,1.034,0,.127-.034.18-.17.177-.352-.008-.7-.007-1.056,0-.125,0-.16-.048-.158-.166.005-.345,0-.69,0-1.034,0-.142-.045-.187-.185-.184-.345.008-.689,0-1.034,0-.119,0-.167-.036-.165-.159.006-.352.007-.7,0-1.055,0-.137.052-.171.178-.169.345.006.689,0,1.034,0,.132,0,.175-.043.172-.174-.007-.344,0-.689,0-1.034,0-.127.034-.18.17-.177.352.008.7.007,1.056,0,.125,0,.16.048.158.166-.005.345,0,.69,0,1.034,0,.142.045.187.185.184.345-.008.689,0,1.034,0,.119,0,.167.036.165.16-.006.352-.007.7,0,1.056,0,.137-.052.174-.178.168-.172-.008-.345,0-.517,0",
    transform: "translate(-67.143 -550.427)",
    fill: "#bbc0c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4256",
    "data-name": "Path 4256",
    d: "M148.208,143.76q6.959,0,13.917,0c.175,0,.227.036.225.219q-.017,1.163,0,2.326c0,.181-.046.221-.223.221q-13.066-.007-26.132,0c-.574,0-1.149-.006-1.723,0-.156,0-.206-.03-.2-.2q.015-1.174,0-2.348c0-.182.048-.221.224-.22q5.914.008,11.827,0h2.09",
    transform: "translate(-128.282 -137.553)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4257",
    "data-name": "Path 4257",
    d: "M148.2,66.016H134.3c-.262,0-.262,0-.222-.261a2.079,2.079,0,0,1,2.1-1.807h24.066a2.084,2.084,0,0,1,2.08,1.834c.031.234.031.234-.212.234H148.2",
    transform: "translate(-128.278 -61.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4258",
    "data-name": "Path 4258",
    d: "M292.138,402.175h-12A2.074,2.074,0,0,1,278,400.041q0-7.164,0-14.328a2.075,2.075,0,0,1,1.791-2.138,1.752,1.752,0,0,1,.3-.018H304.18a2.07,2.07,0,0,1,2.092,2.09q0,7.229,0,14.457a2.069,2.069,0,0,1-2.069,2.07q-6.033,0-12.066,0",
    transform: "translate(-266.004 -367.005)",
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4259",
    "data-name": "Path 4259",
    d: "M169.165,271.6c.962,0,1.923,0,2.885,0,.16,0,.207.035.2.2-.014.344-.01.689,0,1.033,0,.124-.038.154-.157.154q-2.949-.005-5.9,0c-.121,0-.159-.032-.156-.155.008-.351.01-.7,0-1.055,0-.145.043-.176.18-.176.983.006,1.966,0,2.949,0",
    transform: "translate(-158.871 -259.88)",
    fill: "#1a5186"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4260",
    "data-name": "Path 4260",
    d: "M344.9,273.017c-.969,0-1.937,0-2.906,0-.154,0-.212-.025-.2-.2.016-.344.01-.689,0-1.033,0-.12.031-.157.154-.157q2.949.006,5.9,0c.116,0,.163.024.16.151-.009.351-.01.7,0,1.055,0,.139-.034.18-.177.179-.976-.006-1.952,0-2.928,0",
    transform: "translate(-327.045 -259.914)",
    fill: "#1a5186"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4261",
    "data-name": "Path 4261",
    d: "M728.919,447.362a3.2,3.2,0,0,1,2.29.7,3.084,3.084,0,0,1-1.5,5.458,4.582,4.582,0,0,1-2.229-.164,3.092,3.092,0,0,1,.643-5.959,6.465,6.465,0,0,1,.793-.035",
    transform: "translate(-694.166 -428.05)",
    fill: "#1a5186"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4262",
    "data-name": "Path 4262",
    d: "M359.889,703.1c.631,0,1.263,0,1.894,0,.142,0,.183.04.179.181-.009.351-.007.7,0,1.054,0,.109-.028.15-.144.149q-1.926-.005-3.852,0c-.113,0-.147-.037-.145-.148.005-.359.009-.718,0-1.076,0-.145.058-.161.178-.16.631,0,1.263,0,1.894,0",
    transform: "translate(-342.377 -672.755)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4263",
    "data-name": "Path 4263",
    d: "M631.574,703.084c.624,0,1.248,0,1.872,0,.151,0,.2.04.191.192-.011.344-.008.688,0,1.033,0,.118-.027.162-.154.161q-1.915-.007-3.831,0c-.121,0-.161-.035-.158-.157.007-.351.011-.7,0-1.054,0-.153.058-.173.188-.172.631.005,1.263,0,1.894,0",
    transform: "translate(-602.329 -672.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4264",
    "data-name": "Path 4264",
    d: "M775.395,703.078c.624,0,1.248.006,1.872,0,.162,0,.208.042.2.2-.012.344-.007.689,0,1.033,0,.109-.027.15-.144.15q-1.926-.005-3.852,0c-.114,0-.148-.035-.146-.147.006-.359.009-.718,0-1.076,0-.145.057-.161.178-.161.631,0,1.263,0,1.894,0",
    transform: "translate(-739.954 -672.735)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4265",
    "data-name": "Path 4265",
    d: "M503.4,703.1c.516,0,1.033,0,1.549,0,.127,0,.176.027.173.166q-.015.527,0,1.054c0,.139-.046.165-.173.165q-1.56-.007-3.12,0c-.118,0-.164-.028-.161-.154q.012-.538,0-1.076c0-.127.044-.155.161-.154.523.005,1.047,0,1.571,0",
    transform: "translate(-480.024 -672.759)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4266",
    "data-name": "Path 4266",
    d: "M759.4,482.774a2.413,2.413,0,0,1-.892-.1,1.719,1.719,0,0,1,.579-3.348,4.971,4.971,0,0,1,.987.034,1.721,1.721,0,0,1-.329,3.412H759.4",
    transform: "translate(-724.652 -458.637)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card1.54da7f8a9e66ce64dfeedc565dc33815.svg";
export { ForwardRef as ReactComponent };